"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LibsLoader = void 0;
var _libs = require("./libs");
var _logger = require("./logger");
var _jsxRuntime = require("react/jsx-runtime");
const logger = _logger.mainLogger.createChild('LibsLoader');
const LibsLoader = ({
  libs = {}
}) => {
  const names = Object.keys(libs);
  return names.map(name => {
    const {
      enabled = false,
      ...props
    } = libs[name] ?? {};
    if (enabled) {
      const Lib = _libs.libs[name];
      if (typeof Lib === 'undefined') {
        logger.warn(`You're trying to load an unknown Lib "${name}".`);
        return undefined;
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(Lib, {
        ...props
      }, name);
    }
    return undefined;
  });
};
exports.LibsLoader = LibsLoader;
